module.exports = __webpack_public_path__ + "svg/tornado.77de41.svg";